import { IoChevronForward } from "react-icons/io5";
import {  useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useModal } from 'react-hooks-use-modal';
import { useAtom } from 'jotai';
import { activeOrdersAtom, customerAtom } from '../auth';
import { Tabbar } from "../compornents/Tabbar";
import { BirthdayBanner } from "../compornents/BirthdayBanner";
import { SelfGuideBanner } from "../compornents/SelfGuideBanner";
import { Post } from '../compornents/Post';
import { ItemMenu } from '../compornents/ItemMenu';
import { StaffVisitEntry } from '../compornents/StaffVisitEntry';
import { TailSpin } from 'react-loading-icons'
import { toast } from 'react-toastify';
import { Analytics,Gtag } from '../compornents/Analytics';
import OrderStatus from '../compornents/OrderStatus';
import OrderProgress from '../compornents/OrderProgress';
import BagFirstNext from '../compornents/BagFirstNext';
import { RateChangeBanner } from '../compornents/RateChangeBanner';
import { findBagFirstOrder } from '../bagFirst';

function Home() {
  // 初期化
  const [activeOrders, setActiveOrders] = useAtom(activeOrdersAtom);
  const [customer, setCustomer] = useAtom(customerAtom);
  const [isRequesting, setIsRequesting] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {});
  // 受取完了の押し忘れ確認モーダル（2026-08-20）
  const [PickupConfirmModal, openPickupConfirm, closePickupConfirm] = useModal('root', {
    focusTrapOptions: { clickOutsideDeactivates: true },
  });

  // ロッカーを開けた（is_open_box=1）のに「お受け取り完了」が押されず otype=6 のまま
  // 止まっている注文。BOXが解放されず完了クーポン/アンケートも発火しないため、
  // ホームを開いたタイミングで完了を促す（注文1393/1395の押し忘れ事例への対策）。
  const pickupPending = activeOrders.find(
    (o) => Number(o.otype) === 6 && Number(o.is_open_box) === 1
  );

  // 預け側の押し忘れ（2026-09-01 注文1409対策）: セルフ預けでロッカーを開けた
  // (is_open_box=1)のに「お預け完了」が押されず otype=1 のまま止まっている注文。
  // 放置すると督促SMSや（棚出しでbox_idが戻ると）自動キャンセルに向かうため、
  // ホームを開いたタイミングで完了を促す。bag-first進行中(bag_status付き)は対象外。
  const dropoffPending = activeOrders.find(
    (o) => Number(o.otype) === 1 && o.user_dropoff_type === 'own'
      && Number(o.is_open_box) === 1 && String(o.bag_status || '') === ''
  );
  const dropoffSnoozeKey = dropoffPending ? `dropoff_confirm_snooze_${dropoffPending.id}` : '';
  const isDropoffSnoozed = () => {
    try { return localStorage.getItem(dropoffSnoozeKey) === new Date().toDateString(); } catch (e) { return false; }
  };
  const [DropoffConfirmModal, openDropoffConfirm, closeDropoffConfirm] = useModal('root', {
    focusTrapOptions: { clickOutsideDeactivates: true },
  });
  const confirmDropoffDone = async () => {
    if (!dropoffPending || isRequesting) return;
    setIsRequesting(true);
    openLoadingModal();
    try {
      const res = await Post('post', '/order/open_success_box_web.php', { order_id: dropoffPending.id, type: 'dropoff' });
      if (res.result === 1) {
        Gtag('success_dropoff_confirm', { order_id: dropoffPending.id });
        setActiveOrders((prev) => prev.map((o) => (o.id === dropoffPending.id ? res.order : o)));
        closeDropoffConfirm();
        toast.success('お預けありがとうございます。クリーニング完了までお待ちください');
      } else {
        toast.error(res.error_message || '処理に失敗しました');
      }
    } catch (e) {
      toast.error('通信に失敗しました。時間をおいて再度お試しください');
    } finally {
      closeLoadingModal();
      setIsRequesting(false);
    }
  };
  const snoozeDropoffConfirm = () => {
    try { localStorage.setItem(dropoffSnoozeKey, new Date().toDateString()); } catch (e) { /* no-op */ }
    closeDropoffConfirm();
  };
  useEffect(() => {
    if (dropoffPending && !isDropoffSnoozed()) openDropoffConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropoffPending?.id]);
  // 「まだ受け取っていない」を選んだ注文は当日は再表示しない（毎回出て煩わしくならないように）
  const pickupSnoozeKey = pickupPending ? `pickup_confirm_snooze_${pickupPending.id}` : '';
  const isSnoozed = () => {
    try {
      return localStorage.getItem(pickupSnoozeKey) === new Date().toDateString();
    } catch (e) { return false; }
  };

  // 受け取り済み → 完了にする（注文詳細の「お受け取り完了」と同じAPI）
  const confirmPickupDone = async () => {
    if (!pickupPending || isRequesting) return;
    setIsRequesting(true);
    openLoadingModal();
    try {
      const res = await Post('post', '/order/open_success_box_web.php', { order_id: pickupPending.id, type: 'pickup' });
      if (res.result === 1) {
        Gtag('success_pickup', { order_id: pickupPending.id });
        setActiveOrders((prev) => prev.filter((o) => o.id !== pickupPending.id));
        closePickupConfirm();
        toast.success('お受け取り完了ありがとうございます');
      } else {
        toast.error(res.error_message || '処理に失敗しました');
      }
    } catch (e) {
      toast.error('通信に失敗しました。時間をおいて再度お試しください');
    } finally {
      closeLoadingModal();
      setIsRequesting(false);
    }
  };

  const snoozePickupConfirm = () => {
    try { localStorage.setItem(pickupSnoozeKey, new Date().toDateString()); } catch (e) { /* no-op */ }
    closePickupConfirm();
  };

  // 対象注文があり、当日スヌーズ済みでなければ表示する
  useEffect(() => {
    if (pickupPending && !isSnoozed()) openPickupConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickupPending?.id]);

  // bag-first（2026-09-01）で「バッグお届け中／到着済み」の注文。
  // この区間は注文が進んでいるのにお客様には何も起きていないように見え、しかも
  // 次の一手（集荷依頼）はお客様の操作待ちで止まっている。放置＝990円を払ったのに
  // サービスを受けられないので、ホームを「次にやること」の案内板として使う。
  // ※ 上の「受取完了の押し忘れ確認モーダル」(pickupPending) は bag-first とは無関係の別機能なので
  //    フラグに関係なく常に有効。ここから下だけが bag-first の新UI。
  // 判定は bagFirst.js の findBagFirstOrder（注文詳細 [id].jsx と共通・2026-09-03）。
  // 到着済み(arrived)／再依頼(canceled/returned)の分岐は BagFirstNext 内で行う。
  const bagFirstOrder = findBagFirstOrder(activeOrders);

  // 集荷を依頼する（bag_status='arrived' のときだけ押せる）
  const requestPickup = async () => {
    if (!bagFirstOrder || isRequesting) return;
    setIsRequesting(true);
    openLoadingModal();
    try {
      const res = await Post('post', '/order/request_delivery.php', {
        order_id: bagFirstOrder.id,
        type: 'customer_pickup',
      });
      if (res?.result === 1) {
        Gtag('bag_first_request_pickup', { order_id: bagFirstOrder.id });
        navigate(`/home/${bagFirstOrder.id}`);
      } else {
        toast.error(res?.error_message || '集荷のご依頼に失敗しました。時間をおいて再度お試しください');
      }
    } catch (e) {
      toast.error('集荷のご依頼に失敗しました。時間をおいて再度お試しください');
    } finally {
      closeLoadingModal();
      setIsRequesting(false);
    }
  };

  // 専用バッグのお届けを再依頼する（配達失敗時のみ表示）
  const requestBagAgain = async () => {
    if (!bagFirstOrder || isRequesting) return;
    setIsRequesting(true);
    openLoadingModal();
    try {
      const res = await Post('post', '/order/request_delivery.php', {
        order_id: bagFirstOrder.id,
        type: 'delivery_bag',
      });
      if (res?.result === 1) {
        toast.success('専用バッグのお届けを再度手配しました');
        navigate(`/home/${bagFirstOrder.id}`);
      } else {
        toast.error(res?.error_message || 'お届けの再依頼に失敗しました。時間をおいて再度お試しください');
      }
    } catch (e) {
      toast.error('お届けの再依頼に失敗しました。時間をおいて再度お試しください');
    } finally {
      closeLoadingModal();
      setIsRequesting(false);
    }
  };

  // 日付フォーマット関数
  const formatOrderDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}年${month}月${day}日`;
  };

  useEffect(() => {
    Gtag('view_home');
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    let unmounted = false;
    // 注文情報取得
    (async () => {
      openLoadingModal();

      // pパラメータがある場合はlogin処理を先に実行
      const query = new URLSearchParams(location.search);
      const p = query.get('p');
      if (p) {
        const login_data = { p: p };
        await Post('login', '/customer/login.php', login_data);
      }

      // 顧客情報を更新（規約再同意バナーの判定 needs_terms_reagree 等）。
      try {
        const cusRes = await Post('post', '/customer/index.php', {});
        if (!unmounted && cusRes?.result === 1 && cusRes.customer) setCustomer(cusRes.customer);
      } catch (e) { /* 失敗してもホーム表示は継続 */ }

      const request_data = {};
      const response_data = await Post('post', '/order/active.php', request_data);
      // console.log(response_data);
      // console.log(response_data.active_order.length);
      if (response_data.result === 1) {
        const activeOrders = response_data.active_orders;
        // console.log(unmounted);
        if(!unmounted){
          // console.log('setActiveOrders');
          // activeOrderが単一の場合は配列に変換
          setActiveOrders(Array.isArray(activeOrders) ? activeOrders : (activeOrders ? [activeOrders] : []));
        }
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();

    })();
    return () => { unmounted = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <div className="Home">
        <Analytics title="ホーム" />
        <div className="mb-5">
          <div className="home_contents">
            {customer?.needs_terms_reagree && (
              <Link to="/reagree" className="d-block mb-3" style={{ textDecoration: 'none' }}>
                <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 10, padding: '12px 14px', color: '#7a5b00', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 14 }}>📢 利用規約を改定しました。ご確認とご同意をお願いします</span>
                  <IoChevronForward />
                </div>
              </Link>
            )}
            {/* 10/1料金改定の告知（〜9/30 事前・10/1〜10/15 事後・JST判定・×で閉じる） */}
            <RateChangeBanner style={{ marginBottom: 16 }} />
            <BirthdayBanner style={{ marginBottom: 16 }} />
            {/* セルフ未経験(customer.self_used!==1)×セルフ対応拠点のみ。
                bag-first進行中のホームは「次にやること」に集中させるため出さない */}
            {!bagFirstOrder && <SelfGuideBanner style={{ marginBottom: 16 }} />}
            {activeOrders.length > 0 && (
              <div className="mb-4">
                <div className="home_title text-center mb-3">進行中の注文</div>
                {activeOrders.map((order) => (
                  <Link
                    key={order.id}
                    to={`/home/${order.id}`}
                    className="d-block"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div className="order_card">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <div style={{ flex: 1 }}>
                          <div className="order_header" style={{ marginBottom: '6px' }}>
                            <OrderStatus
                              order={order}
                            />
                          </div>
                          <div className="order_item" style={{ color: '#333', fontSize: '18px', fontWeight: 'bold', marginBottom: '4px', textDecoration: 'none' }}>
                            {order.item_name && order.item_name}
                          </div>
                          <div className="order_date" style={{ color: '#666', fontSize: '14px', marginBottom: '2px' }}>
                            {formatOrderDate(order.order_date || order.order_day)}
                          </div>
                        </div>
                        <div className="order_arrow" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '16px' }}>
                          <IoChevronForward style={{ color: '#ccc', fontSize: '20px' }} />
                        </div>
                      </div>
                      <OrderProgress order={order} />
                    </div>
                  </Link>
                ))}
              </div>
            )}
            {/* bag-first: 「次にやること」と唯一のCTA。
                お届け中は①だけが生きていて、到着すると①が済になり②③が生きる。
                いま何をすればいいのかを1画面で分かるようにする。 */}
            {bagFirstOrder && (
              <BagFirstNext
                order={bagFirstOrder}
                onRequestPickup={requestPickup}
                onRequestBagAgain={requestBagAgain}
                isRequesting={isRequesting}
                note="ご注文中のクリーニングが完了するまで、メニューは表示していません"
              />
            )}
            {/* bag-first の進行中はメニューを出さない（いま必要な操作だけに絞る） */}
            {!bagFirstOrder && (
              <div className={activeOrders.length > 0 ? 'mt-3' : ''}>
                <ItemMenu/>
                {/* スタッフ訪問（2026-09-11・#392）。担当店が is_houmon=1 のときだけ出る */}
                <StaffVisitEntry style={{ marginTop: 16 }} />
              </div>
            )}
          </div>
        </div>

        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>

        {/* 受取完了の押し忘れ確認。ロッカーを開けたまま完了されていない注文がある時だけ出す。 */}
        <PickupConfirmModal>
          <div className="modal rounded text-center p-4 m-1" style={{ maxWidth: 340 }}>
            <button onClick={closePickupConfirm} className="hide">閉じる</button>
            <div className="h5 mb-2" style={{ fontWeight: 700 }}>お受け取りは<br />お済みですか？</div>
            <div className="mb-3" style={{ fontSize: 14, lineHeight: 1.7 }}>
              {pickupPending?.item_name ? `${pickupPending.item_name}の` : ''}仕上り品をロッカーから
              お取り出し済みでしたら、<br />下のボタンを押してください。
              <div className="mt-2" style={{ color: '#db2777', fontWeight: 700 }}>
                完了すると300円クーポンを進呈します
              </div>
            </div>
            <button
              className="btn btn-oval btn-own form-control mb-2"
              disabled={isRequesting}
              onClick={confirmPickupDone}
            >
              受け取りました（完了）
            </button>
            <button
              className="btn btn-link form-control"
              style={{ color: '#6b7280', fontSize: 14 }}
              onClick={snoozePickupConfirm}
            >
              まだ受け取っていない
            </button>
          </div>
        </PickupConfirmModal>

        {/* 預け完了の押し忘れ確認（2026-09-01 注文1409対策）。開錠済みなのに「お預け完了」が
            押されていないセルフ預け注文がある時だけ出す。 */}
        <DropoffConfirmModal>
          <div className="modal rounded text-center p-4 m-1" style={{ maxWidth: 340 }}>
            <button onClick={closeDropoffConfirm} className="hide">閉じる</button>
            <div className="h5 mb-2" style={{ fontWeight: 700 }}>お預けは<br />お済みですか？</div>
            <div className="mb-3" style={{ fontSize: 14, lineHeight: 1.7 }}>
              {dropoffPending?.item_name ? `${dropoffPending.item_name}の` : ''}お品物をロッカーへ
              お入れ済みでしたら、<br />下のボタンを押してください。
              <div className="mt-2" style={{ color: '#6b7280', fontSize: 13 }}>
                ※完了の確認ができないままですと、<br />ご注文が自動キャンセルになる場合があります
              </div>
            </div>
            <button
              className="btn btn-oval btn-own form-control mb-2"
              disabled={isRequesting}
              onClick={confirmDropoffDone}
            >
              預けました（完了）
            </button>
            <button
              className="btn btn-link form-control"
              style={{ color: '#6b7280', fontSize: 14 }}
              onClick={snoozeDropoffConfirm}
            >
              まだ預けていない
            </button>
          </div>
        </DropoffConfirmModal>
        <Tabbar menu="home" />
      </div>
    </div>
  );
}

export default Home;
